{
  "name": "mantine-vite-template",
  "private": true,
  "type": "module",
  "version": "0.1.38",
  "scripts": {
    "dev": "vite",
    "build": "tsc && vite build",
    "preview": "vite preview",
    "typecheck": "tsc --noEmit",
    "stylelint": "stylelint '**/*.css' --cache",
    "prettier": "prettier --check \"**/*.{ts,tsx}\"",
    "prettier:write": "prettier --write \"**/*.{ts,tsx}\"",
    "test": "npm run typecheck && npm run prettier && npm run stylelint && npm run build"
  },
  "dependencies": {
    "@hello-pangea/dnd": "^18.0.1",
    "@mantine/carousel": "^8.3.18",
    "@mantine/charts": "^8.3.18",
    "@mantine/core": "^8.3.18",
    "@mantine/dates": "^8.3.18",
    "@mantine/dropzone": "^8.3.18",
    "@mantine/form": "^8.3.18",
    "@mantine/hooks": "^8.3.18",
    "@mantine/notifications": "^8.3.18",
    "@tabler/icons-react": "^3.40.0",
    "@tanstack/react-query": "^5.91.2",
    "@tanstack/react-query-devtools": "^5.91.3",
    "axios": "^1.13.6",
    "dayjs": "^1.11.20",
    "embla-carousel": "^8.6.0",
    "embla-carousel-react": "^8.6.0",
    "encrypt-storage": "^2.14.7",
    "i18next": "^25.8.19",
    "lodash": "^4.17.23",
    "mantine-form-zod-resolver": "^1.3.0",
    "react": "^19.2.4",
    "react-dom": "^19.2.4",
    "react-easy-crop": "^5.5.6",
    "react-error-boundary": "^6.1.1",
    "react-i18next": "^16.5.8",
    "react-query-auth": "^2.4.3",
    "react-router": "^7.13.1",
    "recharts": "3.8.0",
    "zod": "^4.3.6"
  },
  "devDependencies": {
    "@eslint/js": "^10.0.1",
    "@ianvs/prettier-plugin-sort-imports": "^4.7.1",
    "@tanstack/eslint-plugin-query": "^5.91.5",
    "@testing-library/dom": "^10.4.1",
    "@testing-library/react": "^16.3.2",
    "@testing-library/react-hooks": "^8.0.1",
    "@testing-library/user-event": "^14.6.1",
    "@types/lodash": "^4.17.24",
    "@types/node": "^25.5.0",
    "@types/react": "^19.2.14",
    "@types/react-dom": "^19.2.3",
    "@types/react-test-renderer": "^19.1.0",
    "@vitejs/plugin-react": "^6.0.1",
    "axios-mock-adapter": "^2.1.0",
    "eslint": "^10.0.3",
    "eslint-config-prettier": "^10.1.8",
    "eslint-plugin-jsx-a11y": "^6.10.2",
    "eslint-plugin-react": "^7.37.5",
    "eslint-plugin-react-hooks": "^7.0.1",
    "identity-obj-proxy": "^3.0.0",
    "jsdom": "^29.0.0",
    "postcss": "^8.5.8",
    "postcss-preset-mantine": "1.18.0",
    "postcss-simple-vars": "^7.0.1",
    "prettier": "^3.8.1",
    "prop-types": "^15.8.1",
    "react-test-renderer": "^19.2.4",
    "stylelint": "^17.4.0",
    "stylelint-config-standard-scss": "^17.0.0",
    "typescript": "^5.9.3",
    "typescript-eslint": "^8.57.1",
    "vite": "^8.0.1"
  },
  "packageManager": "yarn@4.8.1"
}
